import React, { useEffect } from "react";
import SEO from "../../components/Common/SEO";
import { generateCanonicalUrl } from "../../utils/seoUtils";
import styles from "./sidequest.module.scss";
import Topbar from "./components/Topbar";
import Hero from "./components/Hero";
import Video from "./components/Video";
import Benefits from "./components/Benefits";
import HowItWorks from "./components/HowItWorks";
import FAQ from "./components/FAQ";
import RegisterForm from "./components/RegisterForm";
import Footer from "./components/Footer";

const SidequestPreRegister = () => {
  useEffect(() => {
    const previous = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "smooth";
    return () => {
      document.documentElement.style.scrollBehavior = previous;
    };
  }, []);

  return (
    <div className={styles.page}>
      <SEO
        title="Sidequest Pre-Register | KeyQuest"
        description="Pre-register for KeyQuest access as a Sidequest developer. Submit your details and get verified access once approved."
        canonical={generateCanonicalUrl("/sidequest/pre-register")}
      />

      <Topbar />
      <Hero />
      <Video />
      <RegisterForm />
      <Benefits />
      <HowItWorks />
      <FAQ />
      <Footer />
    </div>
  );
};

export default SidequestPreRegister;
